const addLinkAttributes = (string) => string.replaceAll("a href=", 'a target="_blank" rel="noreferrer" href=')

export default addLinkAttributes;